import React from 'react';
import { AdornmentInput, QuestionMark, SubmitButton, ConnectSlider, InputWrapper } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ButtonWrapper, Information, ErrorMessage } from '../Elements';
import { ComponentsEnum, FlowEnum } from '../../types';
import ApartmentSizeHelp from '../Help/ApartmentSizeHelp';
import useAppartmentSize from './hooks/useAppartmentSize';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const ApartmentSize: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;
  const { classes, t, size, onSizeChange, onChange, toggleHelpModal, register, errors, handleSubmit } =
    useAppartmentSize(nextUrl);

  const { ref, name } = register('size', {
    required: { value: true, message: t('validation_size') },
    min: { value: 25, message: t('validation_size_format') },
    max: { value: 250, message: t('validation_size_format') },
  });
  return (
    <MainLayout
      navigationId={ComponentsEnum.HOUSE_HOLD}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="apartment_size_page_title"
    >
      <HelpModal>
        <ApartmentSizeHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t('apartment_size_title')}>
          <InputWrapper>
            <div className="errorWrapper">
              <div style={{ width: 150, marginRight: 15 }}>
                <AdornmentInput
                  name={name}
                  type="number"
                  value={size || ''}
                  onChange={onSizeChange}
                  error={!!errors.size}
                  adornment="m²"
                  inputRef={ref}
                />
              </div>
              <div className={classes.slider}>
                <ConnectSlider size={size} min={25} max={250} onChange={onChange} />
              </div>
              {!!errors.size && <ErrorMessage>{errors.size.message}</ErrorMessage>}
            </div>
          </InputWrapper>
        </QuestionMark>

        <ButtonWrapper>
          <SubmitButton onClick={handleSubmit}>{t('continue')}</SubmitButton>
          <Information>{t('enter')}</Information>
        </ButtonWrapper>
      </div>
    </MainLayout>
  );
};

export default ApartmentSize;
